<template>
  <div>
    <div class="container">
      <HeadingOne>会員規約等のご確認</HeadingOne>

      <p class="heading-text _mb-md-20 _mb-sm-15">
        下記の会員規約等をご確認のうえ、ページ下部の「同意して申込情報入力へ進む」を押してください。
      </p>
      <p class="txt01">【お手続きにあたってのご注意】</p>
      <ListGroup class="-normal">
        <ListItem class="-normal"
          >お借り入れ、ご返済の際にご利用いただく金融機関の口座情報や、運転免許証番号、お勤め先情報などをお伺いします。お手元に必要な書類（キャッシュカード・運転免許証など）をご用意のうえ、お手続きください。</ListItem
        >
        <ListItem class="-normal"
          >お申し込み手続きの完了を当社が確認できなかったお客さまには、「お客さま情報のご入力」画面に自動表示またはご入力いただいたEメールアドレス（SMSを含みます）または電話番号あてに、お手続きの状況確認およびお手続き再開等のご案内をさせていただく場合がございます。</ListItem
        >
        <ListItem class="-normal"
          >お申し込みの受付からご契約までの間、大切なお知らせやお手続きの状況をご登録のメールアドレスあてにご案内させていただきます。必ず当社からのメールが受信できるよう迷惑メールフィルター等の設定、変更をお願いします。</ListItem
        >
      </ListGroup>
      <ListGroup class="-note">
        <ListItem class="-note"
          >当社からお送りするＥメールアドレスは「****＠system.kddi-fs.com」または「****@email.kddi-fs.com」となります。</ListItem
        >
      </ListGroup>

      <p class="txt01">【お申し込み条件】</p>
      <ListGroup class="-normal">
        <ListItem class="-normal">ご本人さま名義のau IDをお持ちのお客さま（法人契約でご利用のau IDではお申込みいただけません）</ListItem>
        <ListItem class="-normal">満20歳以上、70歳以下のお客さま</ListItem>
        <ListItem class="-normal">ご本人さまに定期収入のある方</ListItem>
        <ListItem class="-normal">携帯電話をお持ちのお客さま</ListItem>
        <ListItem class="-normal">現住所が国内にある方</ListItem>
      </ListGroup>
      <ListGroup class="-note">
        <ListItem class="-note">年金を受給されている場合は、年金以外に安定した収入がある方に限ります。</ListItem>
        <ListItem class="-note important">ご利用時にSMSの追加認証がございます。</ListItem>
        <ListItem class="-note">au PAY カードをお持ちで、キャッシングサービス/キャッシング月々返済（カードローン）をお申し込み中、またはすでに設定されている方は、お申し込みいただけない場合がございます。</ListItem>
      </ListGroup>

      <HeadingTwo>会員規約等</HeadingTwo>
      <p>お申し込みにあたっては、会員規約等を必ずお読みください。</p>

      <CardGroups class="_mb-md-60 _mb-sm-25">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion0" class="-plus">
              <h3 class="heading">重要なお知らせ</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion0" accordion="accordion" :visible="false">
            <CardBody>
              【個人情報の利用について】<br />
              <br />
              KDDI株式会社、沖縄セルラー電話株式会社およびauフィナンシャルサービス株式会社は、<br />
              ・お客さま（以下「会員等」といいます。）のご利用履歴を取得し、個人を特定しない形で第三者へ提供させていただく場合があります。<br />
              ・ご指定のメールアドレスなどへお得な情報や広告などの配信をさせていただきます。なお、会員等がauフィナンシャルサービス株式会社が定める「au
              PAY
              スマートローン会員規約」に定めるサービスの利用停止、法的措置、会員資格取消等となる事由と同等の事由に該当した場合も、当該配信を継続させていただきます。<br />
              詳細は、「au PAY
              スマートローン会員規約」および「KDDI・沖縄セルラーからの重要なお知らせ（個人情報の提供について）」をご確認ください。<br />
              <br />
              【法令で定められる書面の交付について】<br />
              <br />
              ＜マンスリーステートメントの交付＞<br />
              お客さま（以下「会員」といいます。）は、貸金業法第17条第1項書面(以下「お借り入れ明細書」といいます。)及び第18条第1項書面(以下「領収書」といいます。)に代えて、一定期間における貸付及び返済その他の取引状況を記載した書面(以下「マンスリーステートメント」といいます。)を当社所定の方法により交付を受けること、また、貸付及び返済の取引の際に記載事項を簡素化した書面(以下「簡素化書面」といいます。)の交付を受けることをあらかじめ同意するものとします。<br />
              <br />
              ＜電磁的方法による書面の交付＞<br />
              1.会員は、当社が次各号の書面を電磁的方法により交付することに同意するものとします。電磁的方法に係るソフトウェアの種類、バージョン等のファイル記録形式は、当社ホームページにて指定するものとします。<br />
              (1)「au PAY スマートローン会員規約」その他関連規約等<br />
              (2)ご契約内容のご案内の締結前書面<br />
              (3)ご契約内容のご案内<br />
              (4)お借り入れ明細書<br />
              (5)領収書<br />
              (6)マンスリーステートメント及び簡素化書面<br />
              2.会員は、当社から会員に対する前項各号に定める書面を郵送による受け取りに代えて、電磁的方法により確認し、PDFファイル等にダウンロードする等してパソコンに記録する方法により提供を受けるものとします。
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion3" class="-plus">
              <h3 class="heading">
                KDDI・沖縄セルラーからの重要なお知らせ（個人情報の提供について）
              </h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion3" accordion="accordion" :visible="false">
            <CardBody>
              (1)お客さまは、au PAY
              スマートローンのご利用にあたり、KDDI株式会社、沖縄セルラー電話株式会社（以下、併せて「KDDI等」といいます。）が、以下に定めるお客さまの個人情報等（以下「お客さま情報」といいます。）を以下に定める目的で利用するためにauフィナンシャルサービス株式会社（以下「auフィナンシャルサービス」といいます。）へ提供することについて同意するものとします。<br />
              【KDDI等が提供するお客さま情報】<br />
              ①氏名、生年月日、性別、ご自宅住所、お客さまがKDDI等との間で締結している通信サービスの提供に係る契約（以下「回線契約」といい、au
              IDの利用に係る契約と併せて「回線契約等」といいます。）において連絡先としてご登録済みの電話番号およびメールアドレス、回線契約がau（LTE）通信サービスまたはau（WIN）通信サービスの提供に係るものであるときはau携帯電話番号<br />
              ②回線契約の家族割、一括請求等のサービス登録状況<br />
              ③回線契約等の契約内容（契約年数、契約日、解約日を含みます。）、au
              ID<br />
              ④回線契約に係る通信料金等の支払状況および支払額<br />
              ⑤au PAY
              （au かんたん決済）の利用実績、料金支払方法、料金の支払状況および支払額<br />
              ⑥au PAY
              （プリペイドカードを含む）の利用実績、保有Pontaポイント数およびPontaポイントの利用実績<br />
              ⑦保有au ポイント数およびau ポイントの利用実績<br />
              ⑧KDDI等が実施したキャンペーンへの参加実績<br />
              ⑨お客さまがKDDI等との間で締結した各種サービスの提供に係る契約（回線契約等を含みません）の契約内容（契約年数、契約日、解約日を含みます。）、ならびに当該サービスの利用実績、料金の支払状況および支払額<br />
              ⑩通販サイト「au PAYマーケット」に係る購買情報<br />
              【利用目的】<br />
              ①auフィナンシャルサービスが別途定める「au PAY
              スマートローン会員規約」（以下「スマートローン会員規約」といいます。）に基づく契約を含むauフィナンシャルサービスの取引に関する与信判断及び与信後の管理<br />
              ②スマートローン会員規約に基づく契約の成立の事実、会員等管理、各種イベント・プロモーション及び付帯サービスを含むすべての当該規約に基づく契約の履行<br />
              ③auフィナンシャルサービスの事業における新商品、新機能、新サービス等の開発及び市場調査。なお、同社の事業の具体的内容については、同社ホームページ（https://www.kddi-fs.com/）にてご案内致します。<br />
              ④auフィナンシャルサービスの事業における印刷物又は電子メール等による宣伝物の送付及び電話等での営業案内<br />
              ⑤auフィナンシャルサービスが受託して行う宣伝物・印刷物の送付及び電話等による営業案内<br />
              ⑥auフィナンシャルサービスが受託して行う当該受託先と会員等との取引に関する与信判断<br />
              ⑦auフィナンシャルサービスのホームページにおける品質維持・向上等。<br />
              ⑧その他前各号に付随するための業務のため<br />
              (2)KDDI等は、スマートローン会員規約に基づく融資（以下「本サービス」といいます。）の申込手続きを簡易にするため、お客さまがau
              ID、au携帯電話番号またはその他認証情報にてログインを完了した時点で、お客さま情報のうち当該お客さまに係る①の情報を、auフィナンシャルサービスに提供するものとし、当該情報は、auフィナンシャルサービスのau
              PAY
              スマートローンの「お客さま情報のご入力」画面にて自動表示されます。<br />
              (3)KDDI等は、本サービスの申込が完了した時点で、お客さま情報のうち②から⑩までの各情報の全部または一部をauフィナンシャルサービスに提供します。<br />
              (4)KDDI等は、お客さま情報について、auフィナンシャルサービスより、お客さま情報の変更確認等に係る照会を受けた場合、最新のお客さま情報の全部または一部をauフィナンシャルサービスに提供します。<br />
              (5)お客さま情報のうち①の情報に変更があった場合、お客さまは、KDDI等またはauフィナンシャルサービスに当該変更を申告するものとします。なお、KDDI等に申告した場合、KDDI等は、当該申告内容を、auフィナンシャルサービスへ提供します。<br />
              (6)本同意条項の内容は、法令の範囲内で予告なく変更する場合があります。なお、変更する場合は、KDDI等からお知らせします。
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion1" class="-plus">
              <h3 class="heading">au PAY スマートローン会員規約</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion1" accordion="accordion" :visible="false">
            <CardBody>
              第１条（会員）<br />
              「会員」とは、au PAY
              スマートローン会員規約（以下「本規約」といいます。）を極度方式基本契約の契約条項として適用されることを承認のうえ、auフィナンシャルサービス株式会社（以下「当社」といいます。）に入会を申込み、当社が当該申込みを承諾した方をいいます。<br />
              <br />
              第2条（契約の成立及びお客さま番号）<br />
              1.本規約に基づく契約は、申込を当社が承認し、当社所定の手続が完了した日に成立するものとします。<br />
              2.契約が成立した場合、当社は、当社所定の方法にて、契約内容を明らかにする書面（以下「ご契約内容のご案内」といいます。）を交付するとともに、会員に対し、お客さま番号を付与するものとします。<br />
              3.会員は、お客さま番号を善良なる管理者の注意をもって管理するものとし、第三者に対して譲渡または貸与することは一切できないものとします。<br />
              4.会員は、会員がお客さま番号の管理を怠ったことにより生じた損害については、会員の負担となることを予め承諾します。<br />
              <br />
              第3条（極度額及び利用限度額）<br />
              1.極度額は、当社が別途定める金額の範囲内であり、かつ会員が希望した金額の範囲内で、当社が承諾した金額とし、本規約に基づく契約成立にあたり、当社が極度額として、会員に通知した金額とし、ご契約内容のご案内に記載します。<br />
              2.当社は、会員の信用状況に関する当社の審査により、極度額を上限として利用限度額を定めます。会員は利用限度額の範囲内で繰返し借入（以下「借入」といいます。）ができます。<br />
              3.当社は、会員に次の各号のいずれかにあたる事由が生じた場合、会員に予め通知等することなく（次項及び次々項も同様とします。）、極度額又は利用限度額を減額することができます。<br />
              (1)会員が入会申込み時に虚偽の申告をした事が判明したとき。<br />
              (2)本規約に違反したとき、又は債務不履行があったとき。<br />
              (3)会員との信用状況に関する当社の審査により、当社が相当と認めたとき、又は会員の信用状態に著しい変化を生じたとき。<br />
              4.前項に定める他、当社が相当と認めた場合、当社は新たな借入を停止することができます。<br />
              5.当社は第3項又は前項の措置を行った後、会員の信用状況に関する当社の審査により、当社が相当と認めた場合、当社は、当初の極度額又は利用限度額の範囲内で、極度額又は利用限度額を増額し、また、新たな借入の停止を解除することができます。<br />
              <br />
              第4条（暗証番号） <br />
              1.会員及び入会申込者（以下、これらを総称して「会員等」といいます。）は、申込み時又は承認時に暗証番号を当社に届出るものとします。<br />
              なお、会員等は本人の生年月日・電話番号・自宅の番地又はキャッシュカード、クレジットカードなどその他のサービスで用いている暗証番号と同一又は類似の番号等、 他人に推測されやすい数字は暗証番号として申出しないものとします。<br />
              2.会員は、暗証番号を他人に知られないよう善良なる管理者の注意をもって管理するものとします。また、会員は、本人の生年月日・電話番号・自宅の番地又はキャッシュカード、クレジットカードなどのその他サービスで用いている暗証番号と同一又は類似の番号等、本人確認書類等から他人が容易に知り得ることのできる番号、その他、他人に推測されやすい番号を暗証番号としないものとします。<br />
              また、利用の際、登録された暗証番号が使用されたときは、暗証番号について盗用その他の事故があっても、会員はその利用によって生じる一切の債務について、責任を負うものとします。ただし、登録された暗証番号の管理につき、会員に故意または過失が存在しないと当社が認めた場合には、この限りではありません。<br />
              <br />
              第5条（契約期間）<br />
              1.本規約に基づく契約期間は、契約が成立した日から起算して2年間とし、会員は、契約期間中、利用限度額の範囲内で繰返し借入ができます。<br />
              2.契約期間の満了日から起算して30日遡った日より前に、会員又は当社から契約を継続しない旨の意思表示がない場合、契約は、更に2年間自動継続し、以後も同様とします。<br />
              3.契約が自動継続されることなく契約期間の満了により終了した場合、会員は、以後新たな借入ができません。<br />
              4.会員が所定の年齢に達した場合は、契約期間の継続ができないものとします。<br />
              <br />
              第6条（借入利率及び利息の計算方法）<br />
              1.借入利率は、当社所定の利率を適用するものとし、ご契約内容のご案内に記載します。<br />
              2.金融情勢等の著しい変化その他の事由により当社が相当と認めた場合には、当社は、前項の借入利率を変更することができます。<br />
              3.利息の計算方法は、次のとおり1年を365日とする日割計算で算出します。ただし、閏年の場合は、1年を366日とする日割計算で算出します。なお、付利の最小単位は1円とし、小数点以下は切捨てとします。また、利息計算の際は、借入当日は不算入の片端計算とします。<br />
              【利息】＝貸付残高×借入利率（年率）÷365（閏年の場合は366）×ご利用日数<br />
              <br />
              第7条（遅延損害利率及び遅延利息の計算方法）<br />
              1.会員は、借入の返済が遅延した場合、又は第19条の規定により期限の利益を喪失した場合は、第3項に従い、貸付残高に対しいずれも約定返済日又は期限の利益喪失日の翌日から完済の日までの遅延損害金を支払うものとします。<br />
              2.遅延損害金利率は、当社所定の利率を適用するものとし、ご契約内容のご案内に記載します。<br />
              3.遅延損害金は、次のとおり1年を365日とする日割計算で算出します。ただし、閏年の場合は、1年を366日とする日割計算で算出します。なお、付利の最小単位は1円とし、小数点以下は切捨てとします。<br />
              【遅延損害金】＝貸付残高×遅延損害金率(年率)÷365(閏年の場合は366)×遅延経過日数<br />
              <br />
              第8条（借入の方法等）<br />
              1.借入の方法及び場所は、次の各号のとおりとします。<br />
              (1)当社と提携する会社の現金自動入出金機又は現金自動出金機（以下「ATM等」といいます。）を利用する方法。<br />
              (2)会員が保有するau PAY 残高へのチャージによる方法。<br />
              会員が保有するau PAY
              残高へのチャージが可能な場合において、当社は会員の指定に基づきKDDI株式会社（以下「KDDI」といいます。）へ借入金を交付するとともに、同社へ会員が保有するau
              PAY
              残高へのチャージを指示するものとします。当社がKDDIへ借入金を交付した時点で、当社の会員に対する貸付けが完了するものとし、会員は、KDDI所定の手続により借入金相当額のチャージが完了した後において、KDDIが別途定めるau
              PAY 残高に係る規約等に従って当該チャージ金額に係るau PAY
              残高を利用することができます。<br />
              (3)当社からの振込による方法。<br />
              2.会員は、前項各号の方法にて借入れる場合、ATM等の設置店舗の営業時間やシステム保守等により、予告等なく、利用できない時間帯があることを承諾するものとします。<br />
              3.会員は、第1項第2号の方法にて借入れる場合、KDDIが別途定める「ID利用規約」に従い、会員が保有するau
              ID及びこれに紐づくパスワードをau PAY
              残高に設定するものとします。<br />
              4.会員は、第1項第3号の方法にて借入れる場合、次の各号の事項につき承諾するものとします。<br />
              (1)会員が申込振込を受ける金融機関の口座は、会員が予め当社に届出、当社が承諾した口座とします。<br />
              (2)借入日は、会員の金融機関口座への入金に係らず、当社が振込をした日とします。<br />
              <br />
              第9条（お借り入れ明細書の交付）<br />
              1.当社は、会員の借入れの都度、予め会員が当社に届出た送付先に、お借り入れ明細書を交付します。<br />
              2.会員に送付したお借り入れ明細書が当社に返送された場合、当社は、通常到達すべきときに会員に到着したものとみなします。ただし、後に会員から請求があった場合、当社は遅滞なくお借り入れ明細書を再交付します。<br />
              3.お借り入れ明細書に記載する返済期間、返済回数、返済期日又は約定支払額は、借入その他の事由により変動することがあります。<br />
              <br />
              第10条（返済方式及び約定返済額）<br />
              1.返済方式は、元利均等定額の借入時残高スライドリボルビング方式とします。<br />
              2.約定返済額は、借入時の貸付残高区分に応じて決定し、下表に従うものとします。なお、毎月の約定返済額は、新たな借入が発生する都度、その時点における貸付残高に従って決定されます。ただし、最終返済月等、下表の約定返済額を満たない金額の場合は、当該金額を約定返済額とします。<br /><br />
              <img
                src="@/assets/images/en/en001/img01.jpg"
                class="-spnone img-fluid"
                alt=""
              />
              <img
                src="@/assets/images/en/en001/sp/img01.jpg"
                class="-pcnone img-fluid"
                alt=""
              /><br />
              3.当社は、当社所定の方法により会員に対し、当該月の約定返済額の通知をします。会員は、当該通知があったときから、当該約定返済額の返済日（以下「約定返済日」といいます。）までに、追加の借入れをした場合は、当該通知の記載に係らず、前項に従い、当該追加の借入時の貸付残高に基づく約定返済額を支払うものとします。<br />
              4.約定返済日は、毎月26日とします。なお、約定返済日が金融機関休業日の場合は、翌営業日を約定返済日とします。<br />
              <br />
              第11条（支払方法及び支払場所等）<br />
              1.借入金の支払方法及び支払場所は、次の各号のとおりとします。<br />
              (1)会員が借入金の返済のために、予め当社に届出、当社が承諾した金融機関の口座振替による方法。<br />
              (2)ATM等を利用する方法。<br />
              (3)当社の指定する金融機関の口座への振込による方法。<br />
              (4)当社営業所で支払う方法。<br />
              (5)その他当社が指定した前各号以外の方法。<br />
              2.会員は、前項第2号に定める方法で返済する場合は、返済単位は1,000円となります。<br />
              3.会員は、第1項に定める返済に係る費用及び当社からの返金等に要する費用を負担するものとします。<br />
              <br />
              第12条（繰上返済等）<br />
              1.会員は、当社所定の方法によってのみ、約定返済日前であっても、借入金の全部又は一部の返済をすることができます。<br />
              2.会員が、当社に対して繰上返済を行った場合は、次条に定める充当順位により、当社に対するいずれの債務（本規約以外の契約に基づく債務を含みます。）に充当するものとします。<br />
              3.会員は、本条前2項の規定以外の方法で支払金の繰上返済することは一切できないものとします。<br />
              <br />
              第13条（返済額の充当順位）<br />
              返済額の充当順位は、①費用・手数料 ②遅延損害金 ③利息
              ④元金とします。<br />
              <br />
              第14条（返済回数及び最終返済期日）<br />
              返済回数及び最終返済期日は、ご契約内容のご案内に記載します。<br />
              <br />
              第15条（領収書の交付）<br />
              1.当社は、会員からの返済の都度、予め会員が当社に届出た送付先に、領収書を交付します。<br />
              2.会員に送付した領収書が当社に返送された場合、当社は、通常到達すべきときに会員に到着したものとみなすことができます。ただし、後に会員から請求があった場合、当社は遅滞なく領収書を再交付します。<br />
              <br />
              第16条（マンスリーステートメントの交付）<br />
              会員は、貸金業法第17条第1項書面(本規約第9条のお借り入れ明細書)及び第18条第1項書面(本規約第15条の領収書)に代えて、一定期間における貸付及び返済その他の取引状況を記載した書面(以下「マンスリーステートメント」といいます。)を当社所定の方法により交付を受けること、また、貸付及び返済の取引の際に記載事項を簡素化した書面(以下「簡素化書面」といいます。)の交付を受けることをあらかじめ同意するものとします。<br />
              <br />
              第17条（電磁的方法による書面の交付）<br />
              1.会員は、当社が次の各号の書面を電磁的方法により交付することに同意するものとします。電磁的方法に係るソフトウェアの種類、バージョン等のファイル記録形式は、当社ホームページにて指定するものとします。<br />
              (1)本規約その他関連規約等<br />
              (2)ご契約内容のご案内の締結前書面<br />
              (3)ご契約内容のご案内<br />
              (4)第9条に定めるお借り入れ明細書<br />
              (5)第15条に定める領収書<br />
              (6)前条に定めるマンスリーステートメント及び簡素化書面<br />
              2.会員は、当社から会員に対する前項各号に定める書面を郵送による受け取りに代えて、電磁的方法により確認し、PDFファイル等にダウンロードする等してパソコンに記録する方法により提供を受けるものとします。<br />
              <br />
              第18条（届出情報の変更）<br />
              会員は、本規約に基づき当社に届出た氏名・住所・電話番号（連絡先）・取引目的・職業・勤務先・指定銀行口座情報等の変更があった場合は、当社所定の届出又は当社の認める方法により、遅滞なく
              当社に届出なければなりません。なお、会員が届出情報の変更の届出を怠ったことにより、当社からの通知、連絡等が会員に遅滞した場合又は到着しなかった場合、当社は、通常到着すべきときに会員に到着したものとみなします。また、会員が届出情報の変更の届出を怠ったことにより、会員に生じる損害については、当社は故意または重大な過失がある場合を除き責任を負いません。<br />
              <br />
              第19条（期限の利益の喪失）<br />
              1.会員が次の各号のいずれかに該当したときは、当社からの通知、催告がなくても当然に期限の利益を失い、当社に対する一切の未払債務を直ちにお支払いいただきます。<br />
              (1)約定返済日に約定返済額の全部又は一部を怠るなど、本規約に基づく契約に基づく債務を期限までに支払わなかったとき。<br />
              (2)自ら振出した手形、小切手が不渡りになったとき、又は一般の支払いを停止したと当社が判断したとき。<br />
              (3)差押、仮差押、保全差押、仮処分（ただし、信用に関しないものを除く）の申立又は滞納処分を受けたとき。<br />
              (4)会員に破産手続開始、民事再生手続開始の申立があったとき。<br />
              (5)会員資格を第三者に貸与、譲渡、質入れ、担保提供等し、会員以外が利用可能となる状態にしたとき。<br />
              (6)債務整理のための和解、調停等の申立があったとき、又は債務整理のため弁護士等に依頼した旨の通知が当社に到達したとき。<br />
              (7)当社からの書面による通知が申込み時の住所（住所変更がなされた場合は当該変更後の住所）宛に発送されたにもかかわらず、転居先不明、宛所に見当たらず、受取拒否の理由で通知が到達しなかったとき（ただし、通知が到達しなかったことにつき正当な理由があり、通知の名宛人がこれを証明したときは除く。）、その他会員が住所の届出を怠るなど、会員の責に帰すべき事由により当社にとって会員の所在が不明となったとき。<br />
              2.会員が次の各号のいずれかに該当したときは、当社の請求により期限の利益を失い、当社に対する一切の未払債務を直ちに支払うものとします。<br />
              (1)入会申込に際して、虚偽の申告があったとき。<br />
              (2)会員の経営する法人につき、破産手続開始、特別清算開始、会社更生手続開始、民事再生手続開始の申立又は解散その他営業の廃止があったとき。<br />
              (3)本規約に基づく契約以外の当社に対する金銭の支払債務を怠るなど、会員の信用状態が著しく悪化したとき。<br />
              (4)本規約第25条第1項に該当すると当社が判断したとき。<br />
              (5)本規約第26条第1項に該当し又は第2項に違反していると当社が判断したとき。<br />
              (6)その他本規約又はこれに付随する特約等の義務に違反し、その違反が重大な違反となるとき。<br />
              <br />
              第20条（債権譲渡）<br />
              1.会員は、当社が必要と認めた場合、当社が会員に対して有する債権を、取引金融機関（その関連会社を含みます。）・特定目的会社・債権回収会社等に譲渡すること、ならびに当社が譲渡した債権を譲受人から再び譲り受けること、及びこれらに伴い、債権管理に必要な情報を取得・提供することにつき、あらかじめ同意するものとします。<br />
              2.会員は、前項の債権譲渡に関して、当社に対して有し、または将来有することとなる相殺の抗弁、同時履行の抗弁、無効・取消し・解除の抗弁、弁済の抗弁、消滅時効の抗弁その他の一切の抗弁を放棄し、また契約の不成立、不存在を主張しません。<br />
              <br />
              第21条（退会・会員資格の取消し及び利用停止）<br />
              1.会員の都合により退会するときは、本規約末尾に記載の相談窓口あてに、その旨の届出を行うものとします。<br />
              2.会員が次の各号のいずれかに該当した場合、当社は会員に通知することなく、会員が当社から提供をされている本規約に基づく契約の全部または一部の停止、会員資格の取消し、法的措置、その他必要な措置（以下「本件措置」といいます。）をとることができるものとします。<br />
              (1)当社に届出るべき事項に関し届出を怠ったまたは虚偽の申告をした場合。または、当社からの要請があったにも係らず、年収の届出（収入証明書の提出を含みます。）を怠った場合。<br />
              (2)本規約又はこれに付随する特約等に違反し、若しくは違反するおそれがある場合。<br />
              (3)当社との間の契約のいずれかの条項に違反し、もしくは違反するおそれがある場合。<br />
              (4)支払金等当社に対する一切の債務のいずれかの履行を怠った場合。<br />
              (5)本規約第19条に該当した場合。<br />
              (6)以下のいずれかに該当し、又はそのおそれがあると当社が判断した場合。<br />
              イ)当社が把握する会員の年収情報や、職業、年齢等の属性情報等から想定される利用金額又は利用頻度を著しく超える利用金額または利用頻度でなされた本規約に基づく契約の利用。<br />
              ロ)その他本規約に基づく契約の利用目的、利用代金の支払原資、利用金額、利用間隔、過去の利用内容、利用場所等に照らし、不正、不適切または不相当な本規約に基づく契約の利用（第三者による場合も含みます。）。<br />
              (7)本規約第25条第1項に該当する場合等、「犯罪による収益の移転防止に関する法律」に基づき本件措置をとる必要があると当社が判断した場合。<br />
              (8)その他当社が会員として不適格と判断した場合。<br />
              3.会員は退会申出、および会員資格取消し後においても未払債務についてその支払いの責任を負うものとします。なお、当社が請求した場合は、未払債務の全額を一括して直ちに支払うものとします。<br />
              4.会員は、退会、会員資格の取消し等により会員資格を失った後においても、当社が請求したときは、当社の指示する事項について、これに応じる義務を負うものとします。<br />
              5.当社が本件措置をとったことにより、会員に損害が生じた場合であっても、当社に故意または重大な過失がある場合を除き責任を負わないものとします。また、当社に損害が生じたときは、会員がその損害の賠償をする責任を負うものとします。<br />
              <br />
              第22条（契約条件の変更）<br />
              会員は、当社所定の方法により、極度額その他契約条件の変更の手続きをすることができ、当社がこれを承諾した場合に変更されるものとします。<br />
              <br />
              第23条（契約の終了）<br />
              1.本規約に基づく契約は、第5条に定める契約期間の満了により終了します。<br />
              2.本規約に基づく債務を完済した場合、会員は、契約期間中であっても当社所定の方法で通知することで契約を終了させることができます。<br />
              3.第26条第3項の定めにより会員との全ての契約を解除した場合、当社は、会員に対し何ら通知することなく本規約に基づく契約を終了させることができます。<br />
              4.会員が第19条の定めにより本規約に基づく一切の債務について期限の利益を失った場合、当社は、契約期間中であっても契約を終了させることができます。<br />
              5.当社は、本規約に基づく債務を完済した日から、当社において判断した相当期間、新たな借入がなかった場合、会員への通知なく契約を終了させることができます。<br />
              6.契約が終了した場合、会員は、以後新たな借入はできません。<br />
              <br />
              第24条（契約終了後の措置）<br />
              本規約に基づく契約が終了した場合であっても、本規約に基づく債務が残っているとき、会員は、本規約に従うものとし、これに従い残債務を支払うものとします。<br />
              <br />
              第25条（取引時確認および外国政府等における重要な公的地位の保有等に係る届出等）<br />
              1.当社は、「犯罪による収益の移転防止に関する法律」に基づく取引時確認（本人特定事項（氏名・住居・生年月日）、取引目的および職業等の確認）を行うときには、会員等はこれに応ずるものとし、取引時確認の手続きが、当社所定の期間内に完了しない場合（ご入会後、当社より当社が指定する書面の提出及び当社が指定する事項の申告を求めることができるものとし、それを含むものとします）等、取引時確認等が適切に完了しないと当社が判断した場合、その他同法に基づき必要と当社が判断した場合は、入会を謝絶することや、会員資格の取り消し、その他必要な措置を実施することがあります。<br />
              会員等は、本条項に基づく措置につき異議を述べないものとします。<br />
              2.会員等は、本規約に基づく契約の締結及び借入を行う時点において、「犯罪による収益の移転防止に関する法律」並びに同施行令において厳格な取引時確認の対象とされている外国PEPs（外国の元首その他、外国の重要な公的地位にある者及びその家族等として、同施行令において定められているものをいう。以下同じ。）に該当する場合、または該当することとなった場合には、直ちに、当社所定の方法により当社に届け出なければなりません。<br />
              <br />
              第26条（反社会的勢力の排除）<br />
              1.会員等は、暴力団、暴力団員および暴力団員でなくなったときから5年を経過しない者、暴力団準構成員、暴力団関係企業・団体に属する者、総会屋等、社会運動等標ぼうゴロ、特殊知能暴力集団等、これらの共生者、その他これらに準ずる者（以下これらを「暴力団員等」といいます。なお疑いがある場合も含みます。）、テロリスト等（日本政府または外国政府が経済制裁・資産凍結等の対象として指定する者、その他これらに準ずる者を含み、これらに限られません。なお疑いがある場合を含みます。）、または次の各号のいずれかにも該当しないこと、かつ将来にわたっても該当しないことを表明し、保証するものとします。<br />
              (1)自己もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に暴力団員等またはテロリスト等を利用していると認められる関係を有すること。<br />
              (2)暴力団員等またはテロリスト等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること。<br />
              (3)自己もしくは第三者の犯罪収益の隠匿、金融犯罪にかかる取引を行うこと。<br />
              2.会員等は、自ら又は第三者を利用して、暴力的な要求行為、法的な責任を超えた不当な要求、当社との取引に関して脅迫的な言動をし、または暴力を用いる行為、風説を流布し、偽計を用いまたは威力を用いて当社の信用を毀損し、または当社の業務を妨害する行為、その他これらに準ずる行為（以下総称して「不当な請求行為等」といいます。）を行わないことを確約するものとします。<br />
              3.当社は、会員等が前2項の規約に違反している疑いがあると認めた場合には、会員等による新規お申込みを謝絶し、または、何らかの通知、催告を要せずして、本規約に基づく契約の利用の全部若しくは一部の停止、法的措置、会員資格の取消し、その他必要な措置をとることができるものとします。本規約に基づく契約の利用を一時停止した場合には、会員は、当社が利用再開を認めるまでの間、本規約に基づく契約の利用を行うことができないものとします。<br />
              4.前項に定める措置を取ったことにより、会員等に損害が生じた場合でも、会員等は当社に損害賠償の請求をしないものとします。また、当社に損害が生じたときは、会員等がその損害の賠償をする責任を負うものとします。<br />
              <br />
              第27条（マネー・ローンダリング等の禁止）<br />
              1.会員等は、マネー・ローンダリング、テロ資金供与および拡散金融（以下、これらを総称して「マネー・ローンダリング等」という）の目的で、申込、利用をしてはいけないものとします。<br />
              2.当社は、マネー・ローンダリング等防止の目的で、当社へ届出事項の変更の有無、在留資格に関する各種情報やその変更の有無、取引内容の確認およびそれらを裏付ける資料の提出等を求めることができ、当社がそれらを求めた場合、会員等は合理的な期間内にご対応いただくものとします。<br />
              3.当社は、マネー・ローンダリング等のリスクが高いと法令等で指定された特定の国又は地域において、利用を制限する場合があります。また前項について合理的な期間内にご対応いただけない場合、その他マネー・ローンダリング等の利用の懸念があると当社が判断した場合は、利用を停止、その他必要な措置を取ることがあります。会員等は、本条項に基づく措置につき、理由の開示請求、異議を述べないものとします。<br />
              <br />
              第28条（業務委託）<br />
              1.会員等は、当社が当社の指定する委託先に対して、本規約に基づく業務を委託することを予め同意するものとします。<br />
              2.会員等は、当社の指定する委託先が前項の業務を再委託することを予め同意するものとします。<br />
              <br />
              第29条（個人情報等の収集、保有、利用、預託、提供）<br />
              1.会員等は、当社が会員等の個人に関する情報について必要な保護措置を行ったうえで、本規約及び本規約に基づく契約を含む当社の取引に関する与信判断及び与信後の管理（与信判断基準の策定や策定のための分析等を含みます）のために、以下の各号に定める個人情報を収集、保有、利用することを、予め同意するものとします。<br />
              (1)本人を特定するための情報（氏名・生年月日・性別・住所・電話番号・勤務先・Eメールアドレス・家族構成・住居状況・運転免許証番号等の記号番号）、取引目的、職業、その他会員等が入会申込時及び第18条に基づき届け出た事項<br />
              (2)入会申込日・入会承認日・契約の状態・契約期間・振替口座・利用可能枠・会員種類等、会員等と当社との本規約に基づく契約の内容に関する事項（当該契約に係る申込、解約、解除等の事実を含みます。）<br />
              (3)会員の本規約に基づく契約の借入内容、借入状況、返済状況、お電話等での問い合わせ内容及び与信判断や債権回収その他の与信後の管理の過程において当社が知り得た事項<br />
              (4)会員等が入会申込時に届け出た収入・負債、その他当社が収集した本規約に基づく契約に係る利用・支払い履歴<br />
              (5)本人確認書類、収入証明書等、法令等に基づき取得が義務付けられ、または認められることにより会員等が提出した書類の記載事項<br />
              (6)当社が適正かつ適法な方法で収集した住民票等公的機関が発行する書類の記載事項<br />
              (7)電話帳、住宅地図、官報等において公開されている情報<br />
              (8)会員に設定されているau ID、ログインID<br />
              (9)会員等の当社ホームページ等へのアクセス情報（アクセスページ、アクセス日時、ブラウザ情報等）<br />
              (10)Cookie等の端末識別子を通じて収集されたウェブサイト閲覧履歴、メールアドレスに結び付いた個人の年齢・性別・家族構成等、商品購買履歴・サービス利用履歴、位置情報などの情報、個人の興味・関心を示す情報等（当社はこれら情報を第三者から入手し、当社が有する情報と結び付け個人情報として本規約の利用目的の範囲内で使用することがあります。又は、これら情報を第三者へ提供することがあります。）<br />
              (11)前各号に掲げる事項のほか、会員等から申告を受けた情報、当社ウェブサイト利用による情報、公開されている情報その他の当社が適正な手段で取得した情報（個人関連情報を含みます。）<br />
              2.会員等は、当社が、次の各号に定める目的のために、前項各号に定める会員等の情報を収集、利用、保有することを、予め同意するものとします。ただし、会員等が本項第2号に定めるデータ分析、研究、新商品、新機能、新サービス等の開発、市場調査及び概念実証を目的としたアンケート用の書面その他の媒体の送付ならびに本項第3号および本項第4号に定める営業案内での利用について当社に中止を申し出た場合、当社は、業務運営上支障がない範囲でこれを中止するものとします。なお、中止の申出は本規約末尾に記載の相談窓口へ連絡するものとします。また、会員等は本項第9号に定める当社ホームページ等における品質維持・向上のために、当社が前項第11号に定めるアクセス情報の収集を停止することができます。停止方法については、当社ホームページで案内するものとします。<br />
              (1)本規約に基づく契約成立の事実、会員等管理、各種イベント・プロモーション及び付帯サービスを含むすべての本規約に基づく契約の履行<br />
              (2)当社の事業におけるデータ分析、研究、新商品、新機能、新サービス等の開発、市場調査及び概念実証<br />
              なお、当社の事業の具体的内容については、当社ホームページ（https://www.kddi-fs.com/corporate/）にてご案内しています。<br />
              (3)当社の事業における印刷物又は電子メール等による宣伝物の送付及び電話等での営業案内<br />
              (4)当社が受託して行う宣伝物・印刷物の送付及び電話等による営業案内<br />
              (5)当社が受託して行う当該受託先と会員等との取引に関する与信判断<br />
              (6)当社ホームページにおける品質維持・向上等<br />
              (7)その他前各号に付随する業務のため<br />
              3.会員等は、本規約に基づく当社の業務を委託先に委託する場合（再委託、再々委託以降を含む。以下同様）に、業務の遂行に必要な範囲で、本規約に基づき収集した会員等の情報を当該業務委託先に預託又は提供すること及び当該業務委託先が独自に取得した会員等の情報について、当社が提供を受ける場合があることに予め同意するものとします。<br />
              4.会員等は、当社の業務遂行に必要な範囲で、当社及び当社の複数の委託先の間で、本条第1項各号に定める会員等の情報を相互に提供することを予め同意するものとします。<br />
              5.会員等は、当社が、KDDI及び沖縄セルラー電話株式会社（以下、総称して「KDDI 等」といいます。）に対し、本規約に基づく契約を申込した事実及び内容、申込を取消した事実、申込後の当社の手続き状況、契約成立の事実、借入内容、借入状況、借入が停止又は退会・会員資格取消しとなった事実、借入が停止解除となった事実を、入会申込手続、会員等の管理、会員等からの照会対応、本規約に基づく契約に係る諸機能及び特典の提供、借入状況の分析、本規約に基づく契約に係る改善、品質向上、KDDI等が会員等にとって有益と考える情報の掲載又は配信等の目的で提供することを予め同意するものとします。<br />
              6.会員等は、当社が以下の当社の提携会社（以下「提携会社」といいます。）に対し、以下の目的により本条第1項各号に定める個人情報を、保護措置を講じたうえで、提携会社に提供し、当該提携会社が利用することに同意します。<br />
              なお、提携会社には、銀行業、銀行代理業、生命保険業、損害保険業、損害保険代理業、登録金融機関、金融商品取引業、金融先物取引業、金融商品仲介業、確定拠出年金運営管理業、少額短期保険業などの事業を営むものも含まれており、それらに対して非公開金融情報、非公開保険情報、非公開融資等情報などを提供することも含まれます。なお、当社では貸金業、包括信用購入あっせん業、資金移動業、第三者型前払式支払手段発行業、銀行代理業、金融商品仲介業、保険代理業の各業を営んでおり、当社内でこれら事業間での情報交換をすることも含みます。<br />
              【目的】<br />
              提携会社の事業における、データ分析、研究、新商品、新機能、新サービス等の開発、市場調査及び概念実証、新商品情報のお知らせ、関連するアフターサービスおよび宣伝物・印刷物のダイレクトメールの送付、メールの送信、電話等による勧誘等の営業案内のため<br />
              【提携会社】<br />
              KDDI等及びKDDIグループ（https://www.kddi.com/corporate/group/に記載されているグループ会社）<br />
              7.会員等は、当社が各種法令の規定により提出を求められた場合及びそれに準ずる公共の利益のために必要がある場合に、公的機関等に対し個人情報を提供することを予め同意します。<br />
              <br />
              第30条（信用情報機関の利用及び提供）<br />
              会員等は、当社が利用・提供する信用情報機関（個人の支払能力・返済能力に関する信用情報を当該機関に加盟する事業者に提供することを業とするものをいいます。）について、次の各号の目的のために会員等の個人情報が取り扱われることを予め同意するものとします。<br />
              (１)
              会員等および当該契約者の配偶者の本人を特定するための情報（氏名、生年月日、電話番号、本人確認書類の記号番号等、住所等）を当社が加盟する信用情報機関（以下「加盟個人信用情報機関」といいます。）及び当該機関と提携する信用情報機関（以下「提携個人信用情報機関」といいます。）に提供し、会員等および当該契約者の配偶者に関する本項第3号に定める情報を加盟個人信用情報機関ならびに提携個人信用情報機関に照会します。<br />
              上記の照会により、加盟個人信用情報機関ならびに提携個人信用情報機関に会員等および当該契約者の配偶者の信用情報が登録されている場合は、当該信用情報の提供を受け、契約者の支払い能力調査・返済能力調査のために利用します。<br />
              (２)
              加盟個人信用情報機関に、会員等の本規約に基づく信用情報が本規約末尾の「提供情報及び提供期間」表に定める加盟個人信用情報機関に提供します。加盟個人信用情報機関において本規約末尾の「提供情報及び提供期間」表に定める期間保有され、本項第3号から第5号に記載のとおり利用されます。<br />
              (３)
              加盟個人信用情報機関が保有する信用情報<br />
              当社が加盟する加盟個人信用情報機関は、下記の信用情報を保有します。<br />
              イ)	当社を含め、信用情報機関の加盟事業者から提供を受けた情報<br />
              ロ)	信用情報機関が収集したイ)以外の情報<br />
              ハ)	信用情報機関が、保有する信用情報に分析等の処理を行い算出した数値等の情報、その関連情報<br />
              (４)	信用情報機関による信用情報の利用<br />
              当社が加盟する加盟個人信用情報機関は、保有する信用情報を下記のとおり利用します。<br />
              イ)	信用情報の確認、調査、名寄せ、合算、その他信用情報機関の業務を適切に実施するための処理<br />
              ロ)	信用情報の分析等の処理およびそれに基づく数値等の情報の算出<br />
              (５)	信用情報機関による加盟事業者に対する信用情報の提供<br />
              当社が加盟する加盟個人信用情報機関は、本項第3号イ)からハ）を加盟事業者へ提供します。<br />
              また、本項第3号イ）を、提携信用情報機関を通じてその加盟事業者へ提供します。<br />
              <br />
              第31条（個人情報の開示、訂正、削除）<br />
              1.会員等は、当社に対して、当社が保有する自己に関する個人情報について、法令に従い、当該個人情報の開示、利用目的の通知、訂正、追加もしくは削除または利用の停止、消去もしくは提供の停止（以下あわせて「開示等」といいます。）するよう請求できます。なお、開示等請求は本規約末尾に記載の「当社相談窓口」宛に連絡するものとします。<br />
              2.開示等請求により、万一登録内容が不正確又は誤りであることが明らかになった場合、当社は速やかに訂正又は削除に応じるものとします。<br />
              <br />
              第32条（個人情報の取扱いに関する不同意）<br />
              当社は、会員等が入会の申込みに必要な事項の記載を希望されない場合、又は本規約に定める個人情報の取扱いについて同意しない場合は、入会をお断りすることや、契約終了の手続きを取ることがあります。なお、次の各号の利用に対する中止の申出があっても、入会をお断りすることや退会の手続きを取ることはありません。（本条に関する申出は本規約末尾に記載の相談窓口へ連絡するものとします。）<br />
              (1)第29条第2項第2号に定める市場調査を目的としたアンケート用の書面その他の媒体の送付<br />
              (2)第29条第2項第3号又は第4号に定める営業案内<br />
              <br />
              第33条（契約不成立時の個人情報の取扱い）<br />
              入会申込者は、当社が取得した第29条第1項各号の情報について、入会しない場合（当社が入会をお断りする場合を含み、これらに限られません。）であっても、理由のいかんを問わず、第29条に定める目的（ただし、第29条第2項第1号及び第4項に記載のものを除きます。）及び第30条の定めに基づき利用されることを、予め同意します。ただし、第32条第1項各号に基づく中止の申出があった場合、当該利用目的についてはこの限りではありません。<br />
              <br />
              第34条（契約終了者の個人情報の取扱い）<br />
              当社は、本規約に基づく契約終了後も、第28条に定める目的（ただし、第31条第1項各号に記載のものを除きます。）及び開示等請求等に必要な範囲で、法令等又は当社が定める所定の期間個人情報を保有し、利用します。<br />
              <br />
              第35条（条項の変更）<br />
              本規約第29条から第34条までに定める個人情報の取扱いに関する同意条項は、法令に定める手続きに従い、必要な範囲で変更できるものとします。<br />
              <br />
              第36条（準拠法）<br />
              会員と当社との本規約に基づく契約に関する準拠法はすべて日本法が適用されます。<br />
              <br />
              第37条（合意管轄裁判所）<br />
              会員は、本規約について紛争が生じた場合、訴訟額のいかんにかかわらず、会員の住所地及び当社の本社所在地を管轄する簡易裁判所及び地方裁判所を管轄裁判所とします。<br />
              <br />
              第38条（規約の改定、変更、廃止）<br />
              当社は、次の各号に該当する場合には、あらかじめ、効力発生日を定め、本規約を変更（廃止を含みます。以下同じ。）する旨、変更後の内容及び効力発生時期を、当社のホームページにおいて公表するほか、必要があるときにはその他相当な方法で会員に周知した上で、本規約を変更することができるものとします。<br />
              （１）変更の内容が会員の一般の利益に適合するとき。<br />
              （２）変更の内容が本規約に係る取引の目的に反せず、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らし、合理的なものであるとき。<br />
              <br />
              第39条（規約の準用）<br />
              本規約に付随して特約等が存在する場合は、特約等を優先するものとします。<br />
              <br />
              ----------<br />
              《相談窓口》<br />
              ・相談窓口については、本規約に基づく契約以外の商品・サービスなどは、商品・サービスを提供する各社の問い合わせ・相談窓口に連絡ください。<br />
              ・本規約についての問い合わせ・相談、本規約に基づく契約・入退会手続等についてのお問い合せ、届出事項の変更のお申出、当社に対する個人情報の開示等の会員等の個人情報に関する問い合わせ・相談及び宣伝印刷物の送付等の営業案内の中止の申出については下記にご連絡ください。なお、当社では個人情報保護の徹底を推進する管理責任者として個人情報管理統括責任者を設置しております。<br />
              ○ご契約締結前のお客さま<br />
              【au PAY スマートローン 新規入会デスク】<br />
              0120-988-135<br />
              ○ご契約締結後のお客さま<br />
              【au PAY スマートローン 会員さま専用デスク】<br />
              0570-003-858<br />
              023-695-3858<br />
              <br />
              《貸金業相談・紛争解決機関》<br />
              ・貸金業に関するさまざまな相談・問い合わせ・苦情については下記にご連絡ください。<br />
              ○日本貸金業協会 貸金業相談・紛争解決センター 紛争受付課<br />
              電話での受付：0570-051-051または03-5739-3861<br />
              受付時間：9:00～17:00（休：土、日、祝日、年末年始）<br />
              ファックスでの受付：03-5739-3024<br />
              郵便での受付：〒108-0074 東京都港区高輪3-19-15 二葉高輪ビル2階<br />
              日本貸金業協会 貸金業相談・紛争解決センター<br />
              ホームページ：https://www.j-fsa.or.jp/<br />
              <br />
              《加盟個人信用情報機関》<br />
              ・本規約に定める加盟個人信用情報機関ならびに提携個人信用情報機関は以下のとおりです。また、当社が本規約の契約期間中に新たに信用情報機関に加盟し、利用・提供する場合は、別途、会員に対し書面(電磁的記録を含みます。)により通知し、同意を得るものとします。<br />
              <img
                src="@/assets/images/en/en001/img02.png"
                class="-spnone img-fluid"
                alt=""
              />
              <img
                src="@/assets/images/en/en001/sp/img02.png"
                class="-pcnone img-fluid"
                alt=""
              />
              <br />
              <br />
              《提供情報及び提供期間表》<br />
              <img
                src="@/assets/images/en/en001/img03.png"
                class="-spnone img-fluid"
                alt=""
              />
              <img
                src="@/assets/images/en/en001/sp/img03.png"
                class="-pcnone img-fluid"
                alt=""
              />
              <img
                src="@/assets/images/en/en001/img04.png"
                class="-spnone img-fluid"
                alt=""
              />
              <img
                src="@/assets/images/en/en001/sp/img04.png"
                class="-pcnone img-fluid"
                alt=""
              />
              <br /><br />
              <br />
              《提携個人信用情報機関》<br />
              <img
                src="@/assets/images/en/en001/img05.png"
                class="-spnone img-fluid"
                alt=""
              />
              <img
                src="@/assets/images/en/en001/sp/img05.png"
                class="-pcnone img-fluid"
                alt=""
              />
              <br />
              ----------<br />
              改定日：2026年7月1日<br />
              <br />
              サービス運営会社：auフィナンシャルサービス株式会社<br />
              〒108-8618 東京都港区高輪2丁目21番1号<br />
              貸金業登録番号 関東財務局長 第01532号<br />
              日本貸金業協会 協会員番号 日本貸金業協会会員 第006420号<br />
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion2" class="-plus">
              <h3 class="heading">
                WEBおよびスマートフォン専用アプリケーションサービス利用規定
              </h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion2" accordion="accordion" :visible="false">
            <CardBody>
              第1条（会員規定）<br />
              １．WEBおよびスマートフォン専用アプリケーションサービス利用規定（以下「本規定」といいます。）は、auフィナンシャルサービス株式会社（以下「当社」といいます。）が別に定める「au
              PAY
              スマートローン会員規約」（以下「会員規約」といいます。）に定める「会員」（以下「会員」といいます。）に対してインターネット上で提供するWEBサービス（以下「本サービス」といいます。）を会員が利用する場合における遵守事項等について定めるものです。<br />
              ２．会員は、本規定のほか、本サービスにおける各規約、ご案内、ご利用上の注意その他の記載事項を遵守するものとします。<br />
              ３．本規定に定めのない事項及び用語の定義については、会員規約に従うものとします。<br />
              <br />
              第2条（ID・パスワード）<br />
              １．本サービスの利用開始にあたっては、KDDI株式会社（以下「KDDI」といいます。）が会員に発行しているau
              IDが必要となります。会員は、当社所定WEBサイトにおいて、所定の方法で、自己のau
              IDおよびパスワードを入力するものとします。当社が当該au
              ID及びパスワードの有効性の確認をもって、KDDI所定の方法により、KDDIが発行するau
              IDの設定がなされている方（以下「au
              ID会員」といいます。）であることを確認できた場合には、会員は本サービスの利用を開始することができます。<br />
              ２．会員は、前項に基づく本サービスを利用開始手続後、本サービスを利用する場合には、au
              ID、または当社が所定の会員に別途発行するログインID（以下あわせて「ID」といいます。）とパスワードを当社所定WEBサイトにおいて、所定の方法により入力してログインすることが必要です。<br />
              当社は、会員が入力したIDおよびパスワードの有効性、会員情報との一致を確認することにより、当該アクセス者を会員本人とみなします。なお、本サービスを利用するために用いるIDを「本サービスID」といいます。<br />
              なお、au
              IDの設定、利用に関しては、KDDIが別途定める「ID利用規約」が適用されます。<br />
              ３．会員が、本サービスIDとして用いているau IDに紐づくau
              ID会員の資格を喪失するなどの事由が発生した場合、会員がKDDI所定の方法により新たに取得し、当社によりその有効性が確認できた当該au
              IDまたは当社が所定の会員に別途発行したログインIDを本サービスIDとします。<br />
              ４．当社は、会員が指定するIDの有効性が確認された場合、当該利用を当該会員本人による利用とみなし、IDの盗用、不正使用等により会員に生じた損害については、当社は責任を負いません。<br />
              <br />
              第3条（提供するサービス）<br />
              １．会員は、本規定の内容に従って当社所定のWEBサイトまたはスマートフォン専用アプリケーションでログインすることにより、当社または当社の提携する会社がインターネットもしくはアプリケーション上において提供する本サービスを利用することができます。会員が利用できる本サービスおよびその内容については、当社のWEBサイト等で案内するものとします。なお、本サービスにかかるスマートフォン専用アプリケーションにおいては、会員規約に基づく株式会社セブン銀行が設置等するATMを用いた借入にかかる現金出金または返済にかかる現金入金の申込み手続その他の当社所定のサービスを利用することができます。<br />
              ２．当社は、前項の定めにかかわらず本サービスの内容を予告なく変更できるものとします。その結果、会員に不利益が生じても、当社は補償その他の義務を負わないものとします。<br />
              <br />
              第4条（規定の適用および変更）<br />
              当社は、次の各号に該当する場合には、あらかじめ、効力発生日を定め、本規定を変更（廃止を含みます。以下同じ。）する旨、変更後の内容及び効力発生時期を、当社のホームページにおいて公表するほか、必要があるときにはその他相当な方法で会員に周知した上で、本規定を変更することができるものとします。<br />
              （１）変更の内容が会員の一般の利益に適合するとき。<br />
              （２）変更の内容が本規定に係る取引の目的に反せず、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らし、合理的なものであるとき。<br />
              <br />
              第5条（会員の責任）<br />
              １．会員は、自己のIDおよびパスワードの管理、使用について一切の責任を負うものとし、当該IDおよびパスワードを用いてなされた一切の行為について、自己が行ったものとしてみなされることに同意するものとします。IDおよびパスワードの管理不十分、使用上の過誤または第三者の不正利用などによる損害については、当社は故意または重大な過失がある場合を除きその責を負わないものとします。<br />
              ２．会員は、理由の如何を問わず、IDおよびパスワードを第三者に使用させてはならないものとします。<br />
              ３．会員は、申請した内容に変更が生じた場合、または自己のIDおよびパスワードが第三者によって不正に使用されていること、またはその恐れがあることが判明した場合、直ちに当社へ届出て当社からの指示がある場合にはこれに従うものとします。なお、当社への届出は改めて文書で届出ていただく場合があります。また、届出がないことにより会員および第三者に不利益や損害が発生しても、当社は故意または重大な過失がある場合を除きその責任を負わないものとします。<br />
              <br />
              第6条（禁止事項）<br />
              １．会員は、本サービスの利用者として有する権利を第三者に譲渡または担保提供してはならず、もしくは行使させてはならないものとします。<br />
              ２．会員は、本規定に定める事項を遵守するほか、次の行為を行ってはならないものとします。<br />
              (1)本サービスに情報登録を行う際、虚偽の内容を送信または登録する行為<br />
              (2)本サービスにより利用できる情報を改ざんする行為<br />
              (3)有害なコンピュータプログラムなどを送信しまたは書き込む行為<br />
              (4)当社および第三者の著作権その他の知的財産権を侵害しまたは侵害する恐れのある行為<br />
              (5)当社および第三者を誹謗、中傷または名誉を傷つける行為<br />
              (6)当社および第三者の財産、プライバシーを侵害しまたは侵害する恐れのある行為<br />
              (7)本サービスの運営を妨げる行為もしくはその恐れのある行為<br />
              (8)公序良俗に反する内容の情報、文書、図画、図形、音声、動画などを本サービス上で公開する行為<br />
              (9)その他法令に違反する行為もしくはその恐れがある行為<br />
              (10)その他当社が不適当と判断する行為<br />
              <br />
              第7条（サービス停止）<br />
              当社は、会員について以下のいずれかの事由が発生した場合、本サービスの全部または一部を停止できるものとします。<br />
              (1)会員としての資格を喪失した場合<br />
              (2)本規定のいずれかに違反した場合<br />
              (3)その他、当社が不適当と判断した場合<br />
              <br />
              第8条（サービスの一時中断、中止）<br />
              １．当社は、本サービス提供のための装置の保守点検・設備更新・運営上の必要および天災・災害・装置の故障などの事由により本サービスの提供を中断することがあります。これによって会員に損害が生じても、当社はそれについて一切責任を負わないものとします。<br />
              ２．当社は、営業上その他の理由により本サービスを廃止することがあります。その場合は当社所定の方法で、本サービスを通して会員に通知するものとします。<br />
              <br />
              第9条（知的財産権等）<br />
              １．本サービスに関するすべての著作権、商標その他の知的財産権は、すべて当社のほかその権利者に帰属するものであり、会員はそれらの権利を侵害しもしくは侵害する恐れのある行為を行ってはならないものとします。<br />
              ２．会員は、本サービスを利用することにより得られる情報を、権利者の事前の承諾なしに会員自身の私的利用以外の目的で利用することはできないものとします。<br />
              <br />
              第10条（通知）<br />
              １．本サービスの利用および本規定にもとづく会員宛の諸通知は、登録メールアドレスに当該情報が到達した時または本サービスにかかるWEBサイトまたはスマートフォン専用アプリケーション上に通知事項を掲載（通知事項を記載したWEBサイトへのリンクを貼る行為を含みます。）した時をもって、到達したものとします。<br />
              ２．メールの管理を行うプロバイダーのコンピュータシステムの事故、メールアドレスの変更・廃止を行ったにもかかわらず変更後のメールアドレスなどの届出を行わなかった場合は、最終届出のメールアドレス宛に諸通知の情報を送信した時をもって到達したものとします。<br />
              <br />
              第11条（メールサービス）<br />
              １．当社は、会員が当社に届け出たメールアドレス(パソコン･携帯電話・スマートフォン)宛に、当社が会員に対して通知が必要と判断した情報並びに重要なお知らせの通知（以下「重要なお知らせ通知」といいます。）を行うため、メールを送信します。（以下「メールサービス」といいます。）<br />
              ２．前項のメールは、次のいずれかに該当するときは、送信時期が遅れることまたは送信されないことがあります。<br />
              (1)当社が受領するデータの到着が遅れた場合<br />
              (2)当社のシステムメンテナンスによる場合<br />
              (3)会員が当該メールの受信を拒否している場合または容量が不足している場合<br />
              (4)メールサービスの利用を停止した場合または当社が本サービスの利用を不適当と判断した場合<br />
              (5)その他当社が会員にメールを送信できない事情が発生した場合<br />
              ３．当社は、本条第1項の通知メールに記載するべき情報を配信メールに直接記載するものとします。<br />
              ４．会員は、当社が第1項の通知メールにKDDIグループ(当社を含む)の情報を掲載して送信することがあることに同意します。なお、この通知メールは、当社に届け出たキャンペーンなどのお知らせメール(以下「キャンペーンメール」といいます。)配信の可否とは異なり、キャンペーンメール配信を希望しない会員に対しても送信されるものとします。<br />
              第12条（免責事項）<br />
              １．当社は、本サービスの内容および会員が本サービスを通じて得る情報などについて、その完全性、正確性、確実性、有用性などいかなる保証も行いません。また、これらに起因して生じた損害に対しても一切の責任を負わないものとします。<br />
              ２．本サービスにかかるWEBサイトまたはスマートフォン専用アプリケーションの動作に係る不具合、会員が所有するパソコンもしくはスマートフォン端末に与える影響および、会員がWEBサイトまたはスマートフォン専用アプリケーションを正常に利用できないことにより被る不利益については、当社は一切の責任を負わないものとします。<br />
              ３．本サービスにかかるスマートフォン専用アプリケーションが利用できる状態のスマートフォン端末の紛失、盗難等で生じた場合に会員の情報が不正に利用されることによって会員または第三者が被る不利益については、当社は一切責任を負わないものとします。<br />
              <br />
              改定日：2020年6月12日<br />
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>

      <form novalidate @submit.prevent="doLogin">
        <BtngroupSingle class="_mb-md-15 _mb-sm-15">
          <BtnMain class="-main -md" @click.prevent="doLogin">
            同意してauID等でログインのうえ<br />申込情報入力へ進む
          </BtnMain>
        </BtngroupSingle>
      </form>

      <div class="_mb-md-60 _mb-sm-40 -textcenter">
        <strong>au IDをお持ちでない方へ</strong><br />
        お申し込みにはau IDが必要です。<OutLink
          href="https://id.auone.jp/access_chk.html?ctid=idregist&targeturl=https%3A%2F%2Floan.kddi-fs.com%2Fentry%2Fagreement%2F"
          >こちら</OutLink
        >より<br class="-pcnone" />au ID新規登録をお願いいたします。<br />
        <small>※au ID登録後、本ページに戻ることができます。</small>
      </div>

      <BtngroupSingle class="_mb-md-120 _mb-sm-40">
        <BtnBack class="-back -md" router-name="sv001"> 同意しない </BtnBack>
      </BtngroupSingle>
    </div>
  </div>
</template>

<script>
import { initializCredentials } from "@/utils/Auth";
import HeadingOne from "@/components/heading/HeadingOne";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import HeadingTwo from "@/components/heading/HeadingTwo";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import BtnToggle from "@/components/button/BtnToggle";
import CollapseItem from "@/components/collapse/CollapseItem";
import CardBody from "@/components/card/CardBody";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import OutLink from "@/components/link/OutLink";
import { setMeta } from "@/utils/Meta";

export default {
  name: "En001",
  components: {
    BtngroupSingle,
    BtnBack,
    BtnMain,
    CardBody,
    CollapseItem,
    BtnToggle,
    CardHeader,
    CardBox,
    CardGroups,
    HeadingTwo,
    ListItem,
    ListGroup,
    HeadingOne,
    OutLink,
  },
  setup() {
    setMeta({
      title: "会員規約などのご確認",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,会員規約",
    });
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  methods: {
    doLogin: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        initializCredentials("entry")
          .then((res) => {
            let redirectUrl = res.redirect_url;
            window.location.href = redirectUrl;
          })
          .catch((error) => {
            this.goToErrorPage(error);
          });
      } catch (e) {
        this.goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.important {
  color: $red;
}
.card-body {
  word-wrap: break-word;
  white-space: normal;
  width: 100%;
}
.heading-text {
  font-size: 16px;
  font-weight: bold;
  @include mq-up(md) {
    font-size: 20px;
  }
}
</style>
